<template>
  <Layout>
    <PageHeader :title="$t(title) + dirname" :items="items" />
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="col-md-12 mx-auto mt-4">            
            <table class="table table-bordered table-hover">
              <thead class="text-center">
                <th>{{$t('pages.documents.users')}}</th>
                <th>{{$t('pages.documents.access')}}</th>
                <th>{{$t('pages.documents.permission')}}</th>
                <th>{{$t('pages.documents.accesPerm')}}</th>
              </thead>
              <tbody class="text-center">
                <tr v-for="group in groups" :key="group.id">
                  <td>{{ group.name }}</td>
                  <td>
                    <input
                      type="radio"
                      :name="group.id"
                      @change="updatePermission(group.id, dirname, 0)"
                      :checked="user.access == 0 || user.access == null"
                    />
                  </td>
                  <td>
                    <input
                      type="radio"
                      :name="user.userID"
                      @change="updatePermission(group.id, dirname, 2)"
                      :checked="user.access == 2"
                    />
                  </td>
                  <td>
                    <input
                      type="radio"
                      :name="group.id"
                      @change="updatePermission(group.id, dirname, 1)"
                      :checked="group.access == 1"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import userApi from "../../../api/userApi";
import { mapActions } from "vuex";

export default {
  name: "AccessControl",
  components: {
    Layout,
    PageHeader
  },

  data() {
    return {
      checking: 0,
      title: "pages.roles.access_control.title",
      dirname: "",
      items: [
        {
          text: "Dashboard"
        },
        {
          text: "Users"
        },
        {
          text: "Contrôle d'accès",
          active: true
        }
      ],
      groups: {}
    };
  },
  methods: {
    ...mapActions(["permissions"]),
    updatePermission(group, dirname, value) {
      const disk = "public";
      let formData = {
        group_id: group,
        path: dirname+'*',
        disk: disk,
        access: value
      };

      this.permissions(formData).then(changed => {
        if (changed) {
          this.$toasted.success(this.$t('filemanager.modal.properties.addNotification.success'));
        } else {
          this.$toasted.error('filemanager.modal.properties.addNotification.error');
        }
      });
    }
  },

  created() {
    this.dirname = this.$route.params.dir;
    userApi.getAllPermissions(this.dirname).then(res => {
      this.groups = res.data;
    });
  }
};
</script>
